import { Dispatch } from 'redux';
import { Variants } from 'styled-minimal/lib/types';
import { ValueOf } from 'type-fest';

import { AlertPosition, Icons } from './common';

export interface AlertData {
  icon: Icons;
  id: string;
  message: string;
  position: AlertPosition;
  timeout: number;
  variant: Variants;
}

export interface Topic {
  cached: boolean;
  data: Array<Record<string, any>>;
  message: string;
  status: ValueOf<Status>;
  updatedAt: number;
}

export interface GitHubState {
  query: string;
  topics: Record<string, Topic>;
}

export interface WithDispatch {
  dispatch: Dispatch;
}

export interface AppState {
    alerts: AlertData[];
}

export interface UserState {
    isAuthenticated: boolean;
    status: ValueOf<Status>;
}

export interface StoreState {
    app: AppState;
    user: UserState;
}

export enum Status {
    ERROR= 'error',
    IDLE= 'idle',
    READY= 'ready',
    RUNNING= 'running',
    SUCCESS= 'success'
}
